import React, { useState } from "react";
import { Modal, message } from "antd";
import BulkUploadFiles from "../../../../../Images/bulk-upload-files -added-icon.png";

const UploadModal = ({
    title = "Upload",
    open,
    onCancel,
    accountId,
    roleId,
    mutation,
    onSuccess,
}) => {
    const [file, setFile] = useState(null);

    const handleUpload = async () => {
        if (!file) {
            message.error("Please select a file to upload.");
            return;
        }
        if (!["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "text/csv"].includes(file.type)) {
            message.error("Only CSV/XLSX files are supported.");
            return;
        }
        if (!accountId || !roleId || isNaN(parseInt(accountId)) || isNaN(parseInt(roleId))) {
            message.error("Invalid account ID or role ID.");
            return;
        }

        try {
            const variables = {
                document: file,
                accountId: parseInt(accountId),
                roleId: parseInt(roleId),
            };

            const response = await mutation({ variables });

            const mutationData = response.data?.bulkUploadUsers || response.data?.uploadPerformanceExcel;

            if (mutationData?.success) {
                message.success(`${title} completed successfully!`);
                if (onSuccess) {
                    onSuccess(response.data, file.name);
                }
                setFile(null);
            } else {
                // Display the backend error message
                if (mutationData?.message) {
                    message.error(mutationData.message); // ✅ Shows "Error in uploaded file"
                } else {
                    message.error(`Failed to upload ${title.toLowerCase()}. Please try again.`);
                }

                // Handle error file download if URL is provided
                if (mutationData?.data) {
                    const link = document.createElement("a");
                    link.href = mutationData.data;
                    link.download = `performance_upload_error_${file.name || "errors"}.xlsx`;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    // message.success("Error file downloaded!");
                }

                if (onSuccess) {
                    onSuccess(response.data, file.name);
                }
                setFile(null);
            }
        } catch (err) {
            console.error(`${title} error:`, err);
            console.error("GraphQL Errors:", err.graphQLErrors);
            console.error("Network Errors:", err.networkError);
            message.error(`Failed to upload ${title.toLowerCase()}. Please try again.`);
        }
    };

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    const handleModalCancel = () => {
        setFile(null);
        onCancel();
    };

    return (
        <Modal
            title={title}
            open={open}
            onCancel={handleModalCancel}
            footer={null}
            width={600}
            centered
            destroyOnClose
        >
            <div
                style={{
                    padding: "20px",
                    textAlign: "center",
                    border: "2px dashed #ccc",
                    borderRadius: "8px",
                    cursor: "pointer",
                }}
                onClick={() => document.getElementById(`fileUpload-${title.replace(/\s/g, "-")}`).click()}
            >
                <div className="uploadIconOfAddUser">
                    <img src={BulkUploadFiles} alt="Upload Icon" />
                </div>
                <p style={{ fontSize: "16px", fontFamily: "Inter" }}>
                    Drag & Drop files or <span style={{ color: "#c81e1e" }}>Browse</span>
                </p>
                <p style={{ color: "#666", fontSize: "12px", marginTop: "10px" }}>
                    Supported formats: xlsx, csv
                </p>
                <input
                    type="file"
                    id={`fileUpload-${title.replace(/\s/g, "-")}`}
                    style={{ display: "none" }}
                    accept=".xlsx,.csv"
                    onChange={handleFileChange}
                />
            </div>
            {file && (
                <p style={{ textAlign: "center", marginTop: "10px", fontSize: "14px" }}>
                    File Selected: {file.name}
                </p>
            )}
            <div style={{ textAlign: "center", marginTop: "20px" }}>
                <button
                    onClick={handleUpload}
                    disabled={!file}
                    style={{
                        background: file ? "#AD0101" : "#FAC9CA",
                        color: file ? "#FFF" : "#9B9C9C",
                        border: "none",
                        padding: "8px 20px",
                        borderRadius: "4px",
                        transition: "background 0.3s ease-in-out",
                        cursor: file ? "pointer" : "not-allowed",
                        fontWeight: "500",
                    }}
                >
                    Upload File
                </button>
            </div>
        </Modal>
    );
};

export default UploadModal;